export default {
  props: {},
  data() {
    return {
      invoiceTypeData: [],
    };
  },
  methods: {
    getCompDictionary(cb) {
      this.getDictionaryCodeValue('invoice_class,invoice_type', () => {
        this.initInvoiceTypeData();
        if (cb) {
          cb();
        }
      });
    },
    // 组合开票类型数据
    initInvoiceTypeData() {
      /**
       * 新发票类型             旧发票类型       invoiceType      invoiceClass
       * 增值税专用发票（电子）  增值税专用发票    special          electronic
       * 增值税专用发票（纸质）  增值税专用发票    special          paper
       * 普通发票（电子）        增值税普通发票    normal           electronic
       * 普通发票（纸质）        增值税普通发票    normal           paper
       * 专用发票（电子）        专用发票         electron          electronic
       * 专用发票（纸质）        专用发票         electron          paper
       */
      const data = [
        {
          name: this.$t('Common.com_invoice_type_special_electronic'),
          invoiceType: 'special',
          invoiceClass: 'electronic',
        },
        {
          name: this.$t('Common.com_invoice_type_special_paper'),
          invoiceType: 'special',
          invoiceClass: 'paper',
        },
        {
          name: this.$t('Common.com_invoice_type_normal_electronic'),
          invoiceType: 'nomal',
          invoiceClass: 'electronic',
        },
        {
          name: this.$t('Common.com_invoice_type_normal_paper'),
          invoiceType: 'nomal',
          invoiceClass: 'paper',
        },
        // {
        //   name: '专用发票（电子）',
        //   invoiceType: 'electron',
        //   invoiceClass: 'electronic',
        // },
        // {
        //   name: '专用发票（纸质）',
        //   invoiceType: 'electron',
        //   invoiceClass: 'paper',
        // },
      ];
      const invoiceType = this.dicCodeValue.invoice_type;
      const invoiceClass = this.dicCodeValue.invoice_class;
      data.forEach((item) => {
        item.invoiceTypeValue = `${invoiceType[item.invoiceType]}`;
        item.invoiceClassValue = `${invoiceClass[item.invoiceClass]}`;
        item.value = [item.invoiceTypeValue, item.invoiceClassValue].join('_');
      });
      this.invoiceTypeData = data;
    },
    // 获取value对应的对象
    getItem(value) {
      return this.invoiceTypeData.find(item => item.value === `${value}`);
    },
    // 根据invoiceType 和 invoiceClass获取对应的对象
    getItemByTypeAndClass(invoiceType, invoiceClass) {
      return this.invoiceTypeData.find(item => item.invoiceTypeValue === `${invoiceType}` && item.invoiceClassValue === `${invoiceClass}`);
    },
    updateTypeAndClassByValue(context, value) {
      const val = value ? value.split('_') : ['', ''];
      context.invoiceType = val[0];
      context.invoiceClass = val[1];
    },
    initTypeAndClassByValue(context, value) {
      const val = value ? value.split('_') : ['', ''];
      context.invoiceType = context.invoiceType || val[0];
      context.invoiceClass = context.invoiceClass || val[1];
    },
    // 根据invoiceType, invoiceClass 返回对应的中文
    getItemNameByTypeAndClass(invoiceType, invoiceClass) {
      if (this.invoiceTypeData && this.invoiceTypeData.length) {
        const item = this.getItemByTypeAndClass(invoiceType, invoiceClass);
        return item ? item.name : '';
      }
      return '';
    },
  },
};
